import { Pipe, PipeTransform } from '@angular/core';
import { DateService, DATE_FORMAT } from '@yourcause/common';

  @Pipe({
    name: 'gcStartOfDayDateFormatter'
  })
  export class StartOfDayDateFormatterPipe implements PipeTransform {
    constructor (
      private dateService: DateService
    ) { }

    transform (
      date: string,
      format = DATE_FORMAT,
      isStart = true
    ) {
      return this.dateService.getStartOrEndOfDayInUtcFormatted(date, isStart, format);
    }
  }
